<ng-container *eqaLet="refresh$ | async as bars">
	<div *ngIf="bars[0]" eqaScrollbarWrapper class="bar bar_vertical" [class.bar_has-horizontal]="bars[1]">
		<div eqaScrollbar="vertical" class="thumb"></div>
	</div>
	<div *ngIf="bars[1]" eqaScrollbarWrapper class="bar bar_horizontal" [class.bar_has-vertical]="bars[0]">
		<div eqaScrollbar="horizontal" class="thumb"></div>
	</div>
</ng-container>
